export default (props = {}) => <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="tips/check_mark">
<path id="Union" d="M27.8874 9.55101L14.9897 22.4487L12.9323 24.5061L10.8748 22.4487L4.11328 15.6871L6.17073 13.6297L12.9323 20.3912L25.8299 7.49356L27.8874 9.55101Z"/>
</g>
</svg>
